import React from 'react'
import { Helmet } from 'react-helmet'

function TermsAndCondition() {
  return (
    <>
  <Helmet>
        {/* Meta title */}
        <title>Terms and Conditions - St. John's College, Jaffna</title>

        {/* Meta description */}
        <meta 
          name="description" 
          content="Read the terms and conditions for St. John's College, Jaffna. Learn about the guidelines and policies for membership, sports facilities usage, and participation in club events." 
        />

        {/* Keywords for SEO */}
        <meta 
          name="keywords" 
          content="St Johns College Jaffna, sports club terms, conditions, sports facilities, event participation, sports guidelines" 
        />

        {/* Open Graph (OG) tags for social sharing */}
        <meta property="og:title" content="Terms and Conditions - St Johns College Jaffna" />
        <meta 
          property="og:description" 
          content="Review the terms and conditions, facility usage, and event participation at St Johns College Jaffna." 
        />
        <meta property="og:image" content="https://i.ibb.co/54rD2sK/Term-Privacy.png" />
        <meta property="og:url" content="https://stjohns.microwe.net/terms-and-conditions" />
        <meta property="og:type" content="website" />

        {/* Twitter Card tags for social sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms and Conditions - St Johns College Jaffna" />
        <meta 
          name="twitter:description" 
          content="Learn about the terms and conditions for St Johns College Jaffna, facilities, and event participation." 
        />
        <meta name="twitter:image" content="https://stjohns.microwe.net/Term-Privacy.png" />

        {/* Additional meta tags */}
        <meta name="robots" content="index, follow" />
        <meta charSet="utf-8" />
      </Helmet>


    <div className="bg-header-gradient h-[144px] z-10 "></div>
    <div className="pt-[48px] py-[96px] md:px-[24px] px-[16px]">
      <div className="container mx-auto">
        <div className="flex flex-col font-Rubik  gap-[48px]">
          <h2 className="font-medium italic lg:text-[44px] md:text-[40px] text-[32px] text-[#B82222] leading-[150%]">
          TERMS AND CONDITION
          </h2>
          <div className="flex flex-col gap-[32px] te">
            <h3 className="font-medium italic text-[16px] leading-[150%]">
              LOREM IPSUM DOLOR SIT AMET
            </h3>
            <div className="flex flex-col gap-[16px] text-[#212121] font-light">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est laborum.Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt
                ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                quis nostrud exercitation ullamco laboris nisi ut aliquip ex
                ea commodo consequat. Duis aute irure dolor in reprehenderit
                in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt
                in culpa qui officia deserunt mollit anim id est laborum.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat.{" "}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-[32px]">
            <h3 className="font-medium italic text-[16px] leading-[150%]">
              LOREM IPSUM DOLOR SIT AMET
            </h3>
            <div className="flex flex-col gap-[16px] text-[#212121] font-light">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-[32px]">
            <h3 className="font-medium italic text-[16px] leading-[150%]">
              LOREM IPSUM DOLOR SIT AMET
            </h3>
            <ul className="flex flex-col gap-[32px] list-disc pl-[20px]  text-[#212121] font-light">
              <li>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea
              </li>
              <li>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea
              </li>
              <li>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-[32px]">
            <h3 className="font-medium italic text-[16px] leading-[150%]">
              LOREM IPSUM DOLOR SIT AMET
            </h3>
            <div className="flex flex-col gap-[16px] text-[#212121] font-light">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-[32px]">
            <h3 className="font-medium italic text-[16px] leading-[150%]">
              LOREM IPSUM DOLOR SIT AMET
            </h3>
            <div className="flex flex-col gap-[16px] text-[#212121] font-light">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-[32px]">
            <h3 className="font-medium italic text-[16px] leading-[150%]">
              LOREM IPSUM DOLOR SIT AMET
            </h3>
            <div className="flex flex-col gap-[16px] text-[#212121] font-light">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  )
}

export default TermsAndCondition